<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          List of Festival.
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem">Add New Festival</vs-button>
        </h3>
        <p class="card-subtitle">List of Festival.</p>
        <div style="display: flex; flex-direction: row; gap: 1rem">
          <vs-select :color="colorx" label="Language Filter" v-model="search.language" @change="searchData()" style="width: 150px">
            <!-- <vs-select-item value="all" text="All Languages" /> -->
            <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
          </vs-select>

          <!-- 
            <vs-select :color="colorx" label="Sorting Type" v-model="search.sort">
              <vs-select-item value text="Select Sorting" disabled />
              <vs-select-item value="ASC" text="Ascending" />
              <vs-select-item value="DESC" text="Descending" />
            </vs-select>
           -->

          <vs-select :color="colorx" label="Status Filter" v-model="search.status" @change="searchData()" style="width: 100px">
            <vs-select-item value text="Select Status" disabled />
            <vs-select-item value="0" text="All" />
            <vs-select-item value="1" text="Active" />
            <vs-select-item value="2" text="Inactive" />
          </vs-select>

          <vs-select :color="colorx" label="Day Filter" v-model="search.today" @change="searchData()" style="width: 100px">
            <vs-select-item value text="Select Day Filter" disabled />
            <vs-select-item value="0" text="All" />
            <vs-select-item value="1" text="Today" />
          </vs-select>

          <!-- <vs-button color="primary" type="filled" class="searchBtn" @click="searchData()"
              icon="search">Search</vs-button> -->

          <vs-checkbox v-model="search.expandDates" @change="searchData()" color="primary" style="width: 110px; margin-top: 1.2rem">
            Expand Dates
          </vs-checkbox>

          <vs-button color="warning" type="filled" class="searchBtn" icon="cached" @click="resetData()" style="width: 100px"> Reset</vs-button>
        </div>

        <p v-if="this.search.expandDates" style="padding-top: 0.5rem">
          NOTE: Deleting an festival while "Expand Dates" is checked will only remove that festival's shown start and end dates, not the entire
          festival.
        </p>

        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <th></th>
            <th>Festival Name</th>
            <th @click="sortByDate('appearanceDate')" style="cursor: pointer">
              Appearance Date
              <span v-if="sortByField === 'appearanceDate'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <!-- <th @click="sortByDate('startDate')" style="cursor: pointer">
              Start Date
              <span v-if="sortByField === 'startDate'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th @click="sortByDate('endDate')" style="cursor: pointer">
              End Date
              <span v-if="sortByField === 'endDate'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th> -->
            <th>Language</th>
            <th @click="sortBy('status')" style="cursor: pointer">
              Status
              <span v-if="sortByField === 'status'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th>Action</th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item._id">
            <td>{{ index + 1 }}</td>
            <td>
              <img v-if="item.image == '' || item.image == null" src="../../../assets/images/No-image.png" height="50px" width="75px" />
              <img v-else :src="item.image" height="50px" width="75px" />
            </td>
            <td class="td">{{ item.name }}</td>
            <!-- <td class="td">{{ item.startDate | formatDate }}</td> -->
            <!-- <td class="td">{{ item.endDate | formatDate }}</td> -->
            <td style="align-items: center; display: flex; width: 100%">
              <span style="display: flex; flex-direction: column; width: 100%">
                <span> Start Date: {{ item.startDate[item.startDate.length - 1] | formatDate }} </span>
                <span> End Date: {{ item.endDate[item.endDate.length - 1] | formatDate }} </span>
              </span>
              <span style="display: flex; flex-direction: column; padding-left: 1rem" v-if="item.startDate.length > 1 && item.endDate.length > 1">
                +{{ item.startDate.length - 1 }}
                <span class="material-icons" style="cursor: pointer" @click="viewDesc(item)">remove_red_eye</span>
              </span>
            </td>
            <td class="td">{{ item.language }}</td>
            <td class="td">
              <vs-chip v-if="item.status" color="success">Active</vs-chip>
              <vs-chip v-else color="danger">Inactive</vs-chip>
            </td>
            <!-- <td class="td">
              <vs-checkbox v-model="item.disableForAll" @change="updateStatus(item._id, item.disableForAll)"> Disable All Festivals</vs-checkbox>
            </td> -->
            <!-- <td class="td">{{ item.guid }}</td> -->
            <td class="td">
              <vs-button class="mr15 mt-1" icon="create" size="small" color="warning" @click="editingItem(item, 'edit')">Edit</vs-button>
              <vs-button
                class="mr15 mt-1"
                size="small"
                color="danger"
                icon="delete_sweep"
                @click="
                  deleteCategoryPopup = true;
                  itemToDelete = item;
                "
              >
                Delete
              </vs-button>

              <!-- <vs-button class="mr15 mt-1" size="small" color="success"
                @click="editingItem(item, 'clone')">Duplicate</vs-button> -->
            </td>
          </tr>
        </table>

        <!-- Code -->
        <vs-popup :title="isNew ? 'Add New Festival' : clone ? 'Duplicate Festival' : 'Edit Festival'" :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-select
                :color="colorx"
                label="Festival Language"
                @change="fileterusingLanguage($event, cat)"
                v-model="cat.language"
                icon="arrow_downward"
                :disabled="isNew"
              >
                <vs-select-item value text="Choose Language" disabled />
                <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages" :key="index" />
              </vs-select>
            </vs-col>

            <!-- <vs-col vs-lg="6" vs-xs="6">
              <vs-button class="mr15 mt-1" size="small" color="primary" icon="content_copy" @click="copyGuid(cat.guid)"> Copy </vs-button>
            </vs-col> -->
            <vs-col vs-lg="12" vs-xs="12" class="mt-4">
              <vs-input label="Festival Name (Keep it Simple and short)" v-model="cat.name" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="">
              <vs-input label="Festival Id (Keep it 0 can update later)" v-model="cat.enum_id" />
            </vs-col>

            <vs-col vs-lg="6" vs-xs="6" class="">
              <vs-checkbox v-model="cat.status">Status (Active / Inactive)</vs-checkbox>
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="displayImage == ''">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Festival File (Try to use square image)</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event, true)" />
                  </div>
                </vs-col>
                <vs-col v-if="displayImage">
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn" style="z-index: 0" @click="deleteImage(false)"></vs-button>
                  <img :src="displayImage" class="imgUp" height="100px" width="150px" />
                  <b v-if="fileName">File Name : {{ fileName }}</b>
                </vs-col>
              </div>
            </vs-col>

            <div style="display: flex; flex-direction: column; width: 100%; padding-left: 1rem; padding-right: 1rem; padding-bottom: 1rem">
              <label class="vs-input--label" style="padding-bottom: 0.6rem">Appearance Date(s)</label>

              <div
                v-for="(startDate, index) in cat.startDate"
                :key="'startDate-' + index"
                style="display: flex; flex-direction: column; width: 100%; align-items: center; gap: 1rem; margin-bottom: 0.5rem"
              >
                <div style="flex-direction: row; display: flex; width: 100%; align-items: center">
                  <div style="flex: 1">
                    <label>Start Date (pair-{{ index + 1 }})</label>
                    <datepicker v-model="cat.startDate[index]" format="dd-MM-yyyy" style="width: 100%" />
                  </div>

                  <div style="flex: 1">
                    <label>End Date (pair-{{ index + 1 }})</label>
                    <datepicker v-model="cat.endDate[index]" format="dd-MM-yyyy" style="width: 100%" />
                  </div>
                  <vs-button icon="delete" @click="removeCustomKey(index)" color="danger" style="border-radius: 50%; z-index: 0" />
                </div>
                <vs-button v-if="index == cat.startDate.length - 1" icon="add" @click="addCustomKey('startDate')" color="primary" style="z-index: 0">
                  Add pair
                </vs-button>
              </div>

              <vs-button
                icon="add"
                @click="addCustomKey('startDate')"
                color="primary"
                style="width: 25%; z-index: 0"
                v-if="cat.startDate.length == 0 || cat.endDate.length == 0"
              >
                Add pair
              </vs-button>
            </div>

            <vs-col vs-lg="12" vs-xs="12">
              <label>select Article</label>

              <multiselect
                v-model="cat.article"
                placeholder="Select Articles"
                label="name"
                track-by="_id"
                :options="relatedAllArticles"
                :multiple="false"
              ></multiselect>
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12">
              <label>Select Music Category</label>

              <multiselect
                v-model="cat.god"
                placeholder="Select Music Category"
                label="name"
                track-by="_id"
                :options="gods"
                :multiple="false"
              ></multiselect>
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12">
              <label>Select Bhajan</label>

              <multiselect
                v-model="cat.bhajans"
                placeholder="Select Bhajan"
                label="title"
                track-by="_id"
                :options="musicList.bhajans"
                :multiple="true"
              ></multiselect>
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12">
              <label>Select Shlokas</label>

              <multiselect
                v-model="cat.shlokas"
                placeholder="Select shlokas"
                label="title"
                track-by="_id"
                :options="musicList.shlokas"
                :multiple="true"
              ></multiselect>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>Select Mantra</label>

              <multiselect
                v-model="cat.mantras"
                placeholder="Select Mantra"
                label="title"
                track-by="_id"
                :options="musicList.mantras"
                :multiple="true"
              ></multiselect>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>Select Daily Status Category</label>

              <multiselect
                v-model="cat.dailyStatusCategory"
                placeholder="Select Category"
                label="name"
                track-by="_id"
                :options="dailyStatus"
              ></multiselect>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>Related Article</label>

              <multiselect
                v-model="cat.relatedArticles"
                placeholder="Select Articles"
                label="name"
                track-by="_id"
                :options="relatedAllArticles"
                :multiple="true"
              ></multiselect>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="notificationImage == ''">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Notification File (Try to use square image)</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event, false)" />
                  </div>
                </vs-col>
                <vs-col v-if="notificationImage">
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage(true)" style="z-index: 0"></vs-button>
                  <img :src="notificationImage" class="imgUp" height="100px" width="150px" />
                  <b v-if="notificationfileName">File Name : {{ notificationfileName }}</b>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-2 mb-4">
              <vs-checkbox v-model="cat.notification">Notification (Active / Inactive)</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="9" vs-xs="12">
              <vs-button icon="save" @click="btnAddCategory">{{ isNew ? "Save English" : "Update one" }}</vs-button>
              <vs-button icon="save" class="ml-3" @click="createAndtTranslate" v-if="isNew">Save and Translate</vs-button>
              <vs-button icon="save" class="ml-3" @click="updateAndTranslate" v-if="!isNew && !clone && cat.language === 'EN'">Update all</vs-button>
              <vs-checkbox v-model="cat.translate" v-if="!isNew && !clone && cat.language === 'EN'" class="mt-2"> Update translations </vs-checkbox>
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup class="holamundo" title="Delete Festival" :active.sync="deleteCategoryPopup">
          <p>Are you sure you want to delete Festival?</p>
          <div>
            <vs-button icon="delete_forever" class="mr15" @click="deleteCategory">Delete Festival</vs-button>
            <vs-button icon="clear" @click="deleteCategoryPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>

    <!-- view start/endDates in detail -->
    <vs-popup title="View Start and End Dates" :active.sync="viewPopup">
      <div v-html="desc"></div>
    </vs-popup>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import Vue from "vue";
import api from "@/rest.js";
import { API } from "@/common/constants";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD-MM-YYYY");
  }
});

export default {
  name: "Festival",
  components: {
    // uploader,
    Multiselect,
    Datepicker,
  },
  data: () => ({
    title: "Festival",
    colorx: "#0D2144",
    defaultalert: false,
    deleteCategoryPopup: false,
    isNew: true,
    clone: false,
    displayImage: "",
    notificationImage: "",
    fileName: "",
    notificationfileName: "",
    sortDirection: "asd",
    viewPopup: false,
    desc: "",
    sortByField: "",
    search: {
      sort: "ASC",
      language: "EN",
      status: "0",
      today: "0",
      expandDates: false,
    },
    cat: {
      translate: false,
      status: true,
      language: "",
      position: "",
      name: "",
      image: "",
      endDate: [],
      startDate: [],
      article: "",
      relatedArticles: [],
      bhajans: [],
      mantras: [],
      shlokas: [],
      god: null,
      dailyStatusCategory: [],
      notification: false,
      notificationImage: "",
      enum_id: "",
    },
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
    languages: [],
    relatedAllArticles: [],
    musicList: {},
    dailyStatus: [],
    gods: [],
  }),
  computed: {
    sortedData() {
      return this.all.sort((a, b) => {
        let modifier = 1;
        if (this.sortDirection === "desc") modifier = -1;
        if (a[this.sortField] < b[this.sortField]) return -1 * modifier;
        if (a[this.sortField] > b[this.sortField]) return 1 * modifier;
        return 0;
      });
    },
  },
  methods: {
    addCustomKey() {
      this.cat.startDate.push("");
      this.cat.endDate.push("");
    },

    removeCustomKey(index) {
      this.cat.startDate.splice(index, 1);
      this.cat.endDate.splice(index, 1);
    },

    viewDesc(item) {
      this.$data.viewPopup = true;

      const formatDate = (date) => moment(date).format("DD MMM YYYY");

      const maxLength = Math.max(item.startDate.length, item.endDate.length);

      let tableRows = "";
      for (let i = 0; i < maxLength; i++) {
        const startDate = item.startDate[i] ? formatDate(item.startDate[i]) : "—";
        const endDate = item.endDate[i] ? formatDate(item.endDate[i]) : "—";

        tableRows += `<tr>
          <td style="padding: 5px; border: 1px solid #ddd;">${i + 1}</td>
      <td style="padding: 5px; border: 1px solid #ddd;">${startDate}</td>
      <td style="padding: 5px; border: 1px solid #ddd;">${endDate}</td>
    </tr>`;
      }

      this.$data.desc = `<div>
    <table style="width: 100%; border-collapse: collapse; text-align: left;">
      <thead>
        <tr>
          <th style="padding: 8px; border: 1px solid #ddd;">#</th>
          <th style="padding: 8px; border: 1px solid #ddd;">Start Date</th>
          <th style="padding: 8px; border: 1px solid #ddd;">End Date</th>
        </tr>
      </thead>
      <tbody>
        ${tableRows}
      </tbody>
    </table>
  </div>`;
    },

    sortByDate(field) {
      if (this.sortByField === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortByField = field;
        this.sortDirection = "asc";
      }

      this.all.sort((a, b) => {
        let dateA, dateB;

        if (field === "appearanceDate") {
          dateA = a.startDate.length ? new Date(a.startDate[a.startDate.length - 1]) : new Date(0);
          dateB = b.startDate.length ? new Date(b.startDate[b.startDate.length - 1]) : new Date(0);
        }

        return this.sortDirection === "asc" ? dateB - dateA : dateA - dateB;
      });
    },

    sortBy(field) {
      if (this.sortByField === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortDirection = "asc";
      }
      this.sortByField = field;
      this.all.sort((a, b) => {
        let modifier = 1;
        if (this.sortDirection === "asc") modifier = -1;
        if (a[field] < b[field]) return -1 * modifier;
        if (a[field] > b[field]) return 1 * modifier;
        return 0;
      });
    },
    async addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.cat = {
        status: true,
        language: "EN",
        position: "",
        name: "",
        image: "",
        endDate: [],
        startDate: [],
        notification: false,
        notificationImage: "",
        god: null,
      };
      this.$data.displayImage = "";
      this.$data.notificationImage = "";
      if (this.$data.search.language !== "EN")
        await Promise.all([this.getRelatedArticles("EN"), this.getRelatedMusic("EN"), this.fetchAllDailyStatus("EN"), this.fetchAllGods("EN")]);
    },

    editingItem(i, data) {
      let findID = this.$data.search.expandDates ? i._origId : i._id;
      if (data === "edit") this.$data.itemToUpdate = findID;
      else this.$data.itemToUpdate = "";
      this.$data.isNew = false;
      this.$data.clone = data === "clone";
      this.$data.cat = Object.assign({}, i);
      this.$data.displayImage = i.image;
      this.$data.notificationImage = i.notificationImage;
      this.$data.defaultalert = true;

      // api
      //   .get(`${API.FESTIVAL}/${findID}?language=${i.language} `)
      //   .then((response) => {
      //     const festival = response.data;
      //     console.log("festival", response);
      //     if (festival.dailyStatusCategory) {
      //       festival.dailyStatusCategory = festival.dailyStatusCategory.filter((x) => x);
      //     }

      //     this.$data.cat = JSON.parse(JSON.stringify(festival));
      //     this.$data.defaultalert = true;
      //     this.$data.isNew = false;
      //     this.$data.displayImage = festival.image;
      //     this.$data.notificationImage = festival.notificationImage;
      //     this.$data.clone = data === "clone";

      //     this.$vs.loading.close();
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //     this.$vs.loading.close();
      //   });
    },

    async updateAndTranslate() {
      const idExtract = (item, type) => {
        if (item.length > 0) {
          return item.map((x) => {
            if (!x) return null;
            return x[type];
          });
        }
      };

      const guidOrId = (item) => {
        if (item && item.length > 0) {
          return item.map((x) => {
            if (x._id) return x._id;
            else return x.guid;
          });
        }
      };

      const filterNullFromDates = (dates) => {
        return dates.filter((x) => x != "" && x != null);
      };

      this.$data.cat.image = this.$data.displayImage;
      this.$data.cat.notificationImage = this.$data.notificationImage;

      if (!Array.isArray(this.$data.cat.dailyStatusCategory)) this.$data.cat.dailyStatusCategory = [this.$data.cat.dailyStatusCategory];

      const validator = (data) => {
        let missingFields = [];

        if (!data.language) missingFields.push("Language");
        if (!data.name) missingFields.push("Name");
        if (!data.enum_id) missingFields.push("Festival Id");
        if (!data.image) missingFields.push("Image");
        if (!data.startDate || data.startDate.length === 0 || data.startDate.filter((x) => x != "").length === 0) missingFields.push("Start Date");
        if (!data.endDate || data.endDate.length === 0 || data.endDate.filter((x) => x != "").length === 0) missingFields.push("End Date");

        if (data.startDate.length > 1 && data.startDate.filter((x) => x != "").length !== data.endDate.filter((x) => x != "").length) {
          missingFields.push("Make sure each start date has an end date");
        }

        if (missingFields.length > 0) {
          this.$vs.notify({
            text: `Please enter: ${missingFields.join(", ")}`,
            color: "danger",
            position: "top-right",
          });
          return false;
        }

        return true;
      };

      if (!validator(this.$data.cat)) {
        return;
      }

      const [relatedArt, sloks, bhajan, mantra, gods, dailyStatus] = await Promise.all([
        idExtract(this.$data.cat.relatedArticles, "_id"),
        idExtract(this.$data.cat.shlokas, "_id"),
        idExtract(this.$data.cat.bhajans, "_id"),
        idExtract(this.$data.cat.mantras, "_id"),
        idExtract([this.$data.cat.god], "_id"),
        guidOrId(this.$data.cat.dailyStatusCategory),
      ]);

      if (Array.isArray(this.$data.cat.startDate) && Array.isArray(this.$data.cat.endDate)) {
        const startDates = [];
        const endDates = [];

        await Promise.all([
          this.$data.cat.startDate.map(async (date) => {
            if (date) {
              const notPlain = new Date(date);
              const formatted = new Date(
                notPlain.getFullYear() + "/" + (notPlain.getMonth() + 1) + "/" + notPlain.getDate() + " " + "00:00:00"
              ).toISOString();
              startDates.push(formatted);
            }
          }),
          this.$data.cat.endDate.map(async (date) => {
            if (date) {
              const notPlain = new Date(date);
              const formatted = new Date(
                notPlain.getFullYear() + "/" + (notPlain.getMonth() + 1) + "/" + notPlain.getDate() + " " + "23:59:59"
              ).toISOString();
              endDates.push(formatted);
            }
          }),
        ]);

        this.$data.cat.startDate = filterNullFromDates(startDates);
        this.$data.cat.endDate = filterNullFromDates(endDates);
      }

      this.$vs.loading();

      let data = this.$data.cat;
      if (this.$data.cat && this.$data.cat.article && this.$data.cat.article._id) data["article"] = this.$data.cat.article._id;
      data["relatedArticles"] = relatedArt;
      data["bhajans"] = bhajan;
      data["mantras"] = mantra;
      data["shlokas"] = sloks;
      data["gods"] = gods;
      const statutes = dailyStatus.filter((x) => x);
      data["dailyStatusCategory"] = statutes;

      const res = await api.put(`${API.FESTIVAL_U_AND_T}/${data._id}`, data);

      if (res.status == 200) {
        this.$vs.notify({
          text: "Saved Successfully",
          color: "success",
          position: "top-right",
        });
        this.$data.isNew = true;
        this.$data.itemToUpdate = "";
        this.$data.defaultalert = false;
        this.$data.cat = {
          status: true,
          language: "",
          position: "",
          name: "",
          image: "",
          endDate: "",
          startDate: "",
          notification: false,
          notificationImage: "",
          god: null,
        };
        await this.searchData();
        this.$data.displayImage = "";
        this.$data.notificationImage = "";
      }
    },

    async createAndtTranslate() {
      const idExtract = (item, type) => {
        if (item.length > 0) {
          return item.map((x) => {
            if (!x) return null;
            return x[type];
          });
        }
      };

      const guidOrId = (item) => {
        if (item && item.length > 0) {
          return item.map((x) => {
            if (x._id) return x._id;
            else return x.guid;
          });
        }
      };

      const filterNullFromDates = (dates) => {
        return dates.filter((x) => x != "" && x != null);
      };

      this.$data.cat.image = this.$data.displayImage;
      this.$data.cat.notificationImage = this.$data.notificationImage;

      if (!Array.isArray(this.$data.cat.dailyStatusCategory)) this.$data.cat.dailyStatusCategory = [this.$data.cat.dailyStatusCategory];

      const validator = (data) => {
        let missingFields = [];

        if (!data.language) missingFields.push("Language");
        if (!data.name) missingFields.push("Name");
        if (!data.enum_id) missingFields.push("Festival Id");
        if (!data.image) missingFields.push("Image");
        if (!data.startDate || data.startDate.length === 0 || data.startDate.filter((x) => x != "").length === 0) missingFields.push("Start Date");
        if (!data.endDate || data.endDate.length === 0 || data.endDate.filter((x) => x != "").length === 0) missingFields.push("End Date");

        if (data.startDate.length > 1 && data.startDate.filter((x) => x != "").length !== data.endDate.filter((x) => x != "").length) {
          missingFields.push("Make sure each start date has an end date");
        }

        if (missingFields.length > 0) {
          this.$vs.notify({
            text: `Please enter: ${missingFields.join(", ")}`,
            color: "danger",
            position: "top-right",
          });
          return false;
        }

        return true;
      };

      if (!validator(this.$data.cat)) {
        return;
      }

      const [relatedArt, sloks, bhajan, mantra, gods, dailyStatus] = await Promise.all([
        idExtract(this.$data.cat.relatedArticles, "_id"),
        idExtract(this.$data.cat.shlokas, "_id"),
        idExtract(this.$data.cat.bhajans, "_id"),
        idExtract(this.$data.cat.mantras, "_id"),
        idExtract([this.$data.cat.god], "_id"),
        guidOrId(this.$data.cat.dailyStatusCategory),
      ]);

      if (Array.isArray(this.$data.cat.startDate) && Array.isArray(this.$data.cat.endDate)) {
        const startDates = [];
        const endDates = [];

        await Promise.all([
          this.$data.cat.startDate.map(async (date) => {
            if (date) {
              const notPlain = new Date(date);
              const formatted = new Date(
                notPlain.getFullYear() + "/" + (notPlain.getMonth() + 1) + "/" + notPlain.getDate() + " " + "00:00:00"
              ).toISOString();
              startDates.push(formatted);
            }
          }),
          this.$data.cat.endDate.map(async (date) => {
            if (date) {
              const notPlain = new Date(date);
              const formatted = new Date(
                notPlain.getFullYear() + "/" + (notPlain.getMonth() + 1) + "/" + notPlain.getDate() + " " + "23:59:59"
              ).toISOString();
              endDates.push(formatted);
            }
          }),
        ]);

        this.$data.cat.startDate = filterNullFromDates(startDates);
        this.$data.cat.endDate = filterNullFromDates(endDates);
      }

      this.$vs.loading();

      let data = this.$data.cat;
      if (this.$data.cat && this.$data.cat.article && this.$data.cat.article._id) data["article"] = this.$data.cat.article._id;
      data["relatedArticles"] = relatedArt;
      data["bhajans"] = bhajan;
      data["mantras"] = mantra;
      data["shlokas"] = sloks;
      data["gods"] = gods;
      const statutes = dailyStatus.filter((x) => x);
      data["dailyStatusCategory"] = statutes;

      const res = await api.post(API.FESTIVAL_C_AND_T, data);

      if (res.status == 200) {
        this.$vs.notify({
          text: "Saved Successfully",
          color: "success",
          position: "top-right",
        });
        this.$data.isNew = true;
        this.$data.itemToUpdate = "";
        this.$data.defaultalert = false;
        this.$data.cat = {
          status: true,
          language: "",
          position: "",
          name: "",
          image: "",
          endDate: "",
          startDate: "",
          notification: false,
          notificationImage: "",
          god: null,
        };
        await this.searchData();
        this.$data.displayImage = "";
        this.$data.notificationImage = "";
      }
    },

    async btnAddCategory() {
      const idExtract = (item, type) => {
        if (item.length > 0) {
          return item.map((x) => {
            if (!x) return null;
            return x[type];
          });
        }
      };

      const guidOrId = (item) => {
        if (item && item.length > 0) {
          return item.map((x) => {
            if (x._id) return x._id;
            else return x.guid;
          });
        }
      };

      const filterNullFromDates = (dates) => {
        return dates.filter((x) => x != "" && x != null);
      };

      this.$data.cat.image = this.$data.displayImage;
      this.$data.cat.notificationImage = this.$data.notificationImage;

      if (!Array.isArray(this.$data.cat.dailyStatusCategory)) this.$data.cat.dailyStatusCategory = [this.$data.cat.dailyStatusCategory];

      const validator = (data) => {
        let missingFields = [];

        if (!data.language) missingFields.push("Language");
        if (!data.name) missingFields.push("Name");
        if (!data.enum_id) missingFields.push("Festival Id");
        if (!data.image) missingFields.push("Image");
        if (!data.startDate || data.startDate.length === 0 || data.startDate.filter((x) => x != "").length === 0) missingFields.push("Start Date");
        if (!data.endDate || data.endDate.length === 0 || data.endDate.filter((x) => x != "").length === 0) missingFields.push("End Date");

        if (data.startDate.length > 1 && data.startDate.filter((x) => x != "").length !== data.endDate.filter((x) => x != "").length) {
          missingFields.push("Make sure each start date has an end date");
        }

        if (missingFields.length > 0) {
          this.$vs.notify({
            text: `Please enter: ${missingFields.join(", ")}`,
            color: "danger",
            position: "top-right",
          });
          return false;
        }

        return true;
      };

      if (!validator(this.$data.cat)) {
        return;
      }

      const [relatedArt, sloks, bhajan, mantra, gods, dailyStatus] = await Promise.all([
        idExtract(this.$data.cat.relatedArticles, "_id"),
        idExtract(this.$data.cat.shlokas, "_id"),
        idExtract(this.$data.cat.bhajans, "_id"),
        idExtract(this.$data.cat.mantras, "_id"),
        idExtract([this.$data.cat.god], "_id"),
        guidOrId(this.$data.cat.dailyStatusCategory),
      ]);

      if (Array.isArray(this.$data.cat.startDate) && Array.isArray(this.$data.cat.endDate)) {
        const startDates = [];
        const endDates = [];

        await Promise.all([
          this.$data.cat.startDate.map(async (date) => {
            if (date) {
              const notPlain = new Date(date);
              const formatted = new Date(
                notPlain.getFullYear() + "/" + (notPlain.getMonth() + 1) + "/" + notPlain.getDate() + " " + "00:00:00"
              ).toISOString();
              startDates.push(formatted);
            }
          }),
          this.$data.cat.endDate.map(async (date) => {
            if (date) {
              const notPlain = new Date(date);
              const formatted = new Date(
                notPlain.getFullYear() + "/" + (notPlain.getMonth() + 1) + "/" + notPlain.getDate() + " " + "23:59:59"
              ).toISOString();
              endDates.push(formatted);
            }
          }),
        ]);

        this.$data.cat.startDate = filterNullFromDates(startDates);
        this.$data.cat.endDate = filterNullFromDates(endDates);
      }

      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      this.$vs.loading();
      let apiToCall = API.FESTIVAL;
      let data = this.$data.cat;
      if (this.$data.cat && this.$data.cat.article && this.$data.cat.article._id) data["article"] = this.$data.cat.article._id;
      data["relatedArticles"] = relatedArt;
      data["bhajans"] = bhajan;
      data["mantras"] = mantra;
      data["shlokas"] = sloks;
      data["gods"] = gods;
      const statutes = dailyStatus.filter((x) => x);
      data["dailyStatusCategory"] = statutes;

      if (!this.$data.isNew && !this.$data.clone) {
        apiToCall = API.FESTIVAL;
        data["image"] = this.$data.displayImage;
        data["notificationImage"] = this.$data.notificationImage;
        api
          .put(apiToCall + "?id=" + data._id, data, { headers })
          .then((r) => {
            this.$vs.loading.close();
            if (this.$route.query.language) {
              this.$router.push({ path: "/calendar" });
            }
            // this.fetchAllCategory();
            if (r.status === 200) {
              this.$vs.notify({
                text: "Saved Successfully",
                color: "success",
                position: "top-right",
              });
              this.$data.isNew = true;
              this.$data.itemToUpdate = "";
              this.$data.defaultalert = false;
              (this.$data.cat = {
                status: true,
                language: "",
                position: "",
                name: "",
                image: "",
                endDate: "",
                startDate: "",
                notification: false,
                notificationImage: "",
              }),
                this.searchData();
            }
          })
          .catch((error) => {
            console.log(error);
            this.$vs.loading.close();
          });
        this.$data.defaultalert = false;
        return;
      }
      if (!this.$data.isNew && !this.$data.clone) {
        this.$data.displayImage = "";
        this.$data.notificationImage = "";
      }
      if (this.$data.clone) {
        apiToCall = API.FESTIVAL;

        data = {
          name: this.$data.cat.name,
          position: this.$data.cat.position,
          language: this.$data.cat.language,
          status: this.$data.cat.status,
          image: this.$data.cat.image,
          startDate: this.$data.cat.startDate,
          endDate: this.$data.cat.endDate,
          article: this.$data.cat.article,
          relatedArticles: relatedArt,
          bhajans: bhajan,
          mantras: mantra,
          shlokas: sloks,
          gods: gods,
          notificationImage: this.$data.cat.notificationImage,
          notification: this.$data.cat.notification,
          dailyStatusCategory: this.$data.cat.dailyStatusCategory,
          enum_id: this.$data.cat.enum_id,
        };
      }
      api
        .post(apiToCall, data, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status == 200) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            (this.$data.cat = {
              status: true,
              language: "",
              position: "",
              name: "",
              image: "",
              endDate: "",
              startDate: "",
              notification: false,
              notificationImage: "",
              god: null,
            }),
              this.searchData();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    async fetchAllCategory() {
      this.$vs.loading();
      try {
        const res = await api.get(API.FESTIVAL, {});
        if (res.status) {
          for (const item of res.data.data) {
            if (typeof item.startDate === "string") {
              item.startDate = [item.startDate];
            } else if (item.startDate.length == 0) {
              item.startDate = [""];
            } else {
              item.startDate = item.startDate;
            }

            if (typeof item.endDate === "string") {
              item.endDate = [item.endDate];
            } else if (item.endDate.length == 0) {
              item.endDate = [""];
            } else {
              item.endDate = item.endDate;
            }
          }
          this.$data.all = res.data.data;
          // const allIds = this.$data.all.map((item) => item._id);
          this.sortByDate("appearanceDate");

          const targetId = this.$route.query.id;
          const targetItem = this.all.find((item) => item._id === targetId);
          if (targetItem) {
            this.editingItem(targetItem, "edit");
          }
        }
      } catch (error) {
      } finally {
        this.$vs.loading.close();
      }
    },

    async deleteCategory() {
      try {
        let headers = {
          "Content-Type": "application/json;charset=utf-8",
        };

        if (JSON.parse(localStorage.user).token) {
          headers["x-master-token"] = JSON.parse(localStorage.user).token;
        }

        let finalId = this.$data.itemToDelete._origId || this.$data.itemToDelete._id;
        const requestedDeleteDatePair = {
          startDate: this.$data.itemToDelete.startDate[0],
          endDate: this.$data.itemToDelete.endDate[0],
        };

        const res = await api.delete(`${API.FESTIVAL}/?id=${finalId}&fromExpanded=${this.$data.search.expandDates}`, {
          headers,
          data: requestedDeleteDatePair,
        });

        if (res.status) {
          this.$vs.notify({
            text: "Deleted Successfully",
            color: "success",
            position: "top-right",
          });

          await this.searchData();
        }
      } catch (error) {
        console.error("Error deleting category:", error);
        this.$vs.notify({
          text: "Error deleting category",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$data.deleteCategoryPopup = false;
        this.$vs.loading.close();
      }
    },

    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data;
        })
        .catch(() => {});
    },
    async searchData() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      this.$vs.loading();
      try {
        await Promise.all([
          this.getRelatedArticles(this.$data.search.language),
          this.getRelatedMusic(this.$data.search.language),
          this.fetchAllDailyStatus(this.$data.search.language),
          this.fetchAllGods(this.$data.search.language),
        ]);

        const res = await api.get(API.FESTIVAL, {
          headers,
          params: {
            sort: this.$data.search.sort,
            language: this.$data.search.language,
            status: this.$data.search.status,
            today: this.$data.search.today,
            expandDates: this.$data.search.expandDates,
          },
        });

        if (res.status) {
          for (const item of res.data.data) {
            if (typeof item.startDate === "string") {
              item.startDate = [item.startDate];
            } else if (!Array.isArray(item.startDate) || item.startDate.length === 0) {
              item.startDate = [""];
            }

            if (typeof item.endDate === "string") {
              item.endDate = [item.endDate];
            } else if (!Array.isArray(item.endDate) || item.endDate.length === 0) {
              item.endDate = [""];
            }
          }

          res.data.data.sort((a, b) => {
            const dateA = new Date(a.startDate[0]);
            const dateB = new Date(b.startDate[0]);
            return dateA - dateB;
          });

          this.$data.all = res.data.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    uploadImage(data, flag) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      if (flag) {
        this.$data.fileName = data.target.files[0].name;
      } else {
        this.$data.notificationfileName = data.target.files[0].name;
      }

      formdata.append("category", this.$data.cat.name);
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            if (flag) {
              this.$data.displayImage = response.data.files[0].url;
            } else {
              this.$data.notificationImage = response.data.files[0].url;
            }

            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
      // }
    },
    deleteImage(flag) {
      if (!flag) {
        this.$data.displayImage = "";
      } else {
        this.$data.notificationImage = "";
      }
    },
    resetData() {
      this.$data.search = {
        sort: "ASC",
        language: "EN",
        status: "0",
        today: "0",
        expandDates: false,
      };
      this.searchData();
    },

    async fileterusingLanguage(event, item) {
      try {
        if (!event || !item) return;
        await Promise.all([this.getRelatedArticles(event), this.getRelatedMusic(event), this.fetchAllDailyStatus(event), this.fetchAllGods(event)]);
        let id = item.ref || item._id;
        this.$vs.loading();
        const res = await api.get(`${API.FESTIVAL}/${id}?language=${event}`);

        if (res.status === 200) {
          if (typeof res.data.startDate === "string") {
            res.data.startDate = [res.data.startDate];
          } else if (res.data.startDate.length == 0) {
            res.data.startDate = [""];
          } else {
            res.data.startDate = res.data.startDate;
          }

          if (typeof res.data.endDate === "string") {
            res.data.endDate = [res.data.endDate];
          } else if (res.data.endDate.length == 0) {
            res.data.endDate = [""];
          } else {
            res.data.endDate = res.data.endDate;
          }
          // console.log(res.data);
          this.$data.cat = Object.assign({}, res.data);
          this.$data.displayImage = res.data.image;
          this.$data.notificationImage = res.data.notificationImage;
          this.$vs.loading.close();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    copyGuid(guid) {
      var input_temp = document.createElement("input");
      input_temp.value = guid;
      document.body.appendChild(input_temp);
      input_temp.select();
      document.execCommand("copy");
      document.body.removeChild(input_temp);
      this.$vs.notify({
        text: "GUID copied",
        color: "success",
        position: "top-right",
      });
    },
    async getRelatedArticles(language = null) {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      this.$vs.loading();
      try {
        const response = await api.get(`${API.ARTICLE}/plain?language=EN&status=1`, {
          headers,
          params: {
            language: language,
          },
        });
        this.$data.relatedAllArticles = response.data.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    getRelatedMusic(language = null) {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      this.$vs.loading();
      api
        .get(API.GET_MUSIC + "/related", {
          headers,
          params: {
            language: language,
          },
        })
        .then((r) => {
          this.$vs.loading.close();
          this.$data.musicList = r.data;
        })
        .catch(() => {});
    },
    async fetchAllDailyStatus(language = null) {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      this.$vs.loading();

      try {
        const res = await api.get(API.GET_CAT + `/plain?language=${language}&sort=ASC&status=1`, {
          headers,
        });

        if (res.status === 200) {
          this.$data.dailyStatus = res.data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    // viewAll(i) {
    //   // console.log(i._id);
    //   // this.$router.push("/articles/" + i._id);
    // },
    // async updateStatus(id, data) {
    //   this.$vs.loading();
    //   try {
    //     const res = await api.put(API.FESTIVAL + "/disable" + "?id=" + id, { status: data });
    //     if (res.status == 200) {
    //       this.$vs.notify({
    //         text: "Status Updated",
    //         color: "success",
    //         position: "top-right",
    //       });
    //       await this.searchData();
    //       this.$vs.loading.close();
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
    async fetchAllGods(event) {
      this.$vs.loading();
      try {
        const res = await api.get(API.GET_GODS_DASH, {
          params: {
            position: this.$data.search.sort,
            language: event ? event : this.$data.search.language,
            plain: true,
          },
        });

        if (res.status) {
          this.$data.gods = res.data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    toggleExpandDates() {
      if (this.$data.search.expandDates) {
        // Expand the list by duplicating festivals for each appearance date
        const expandedList = [];
        this.$data.all.forEach((festival) => {
          if (Array.isArray(festival.startDate)) {
            festival.startDate.forEach((date, index) => {
              const clonedFestival = { ...festival };
              clonedFestival.startDate = [date];
              clonedFestival.endDate = [festival.endDate[index] || ""];
              expandedList.push(clonedFestival);
            });
          } else {
            expandedList.push(festival);
          }
        });
        this.$data.all = expandedList;
      } else {
        // Fetch the original list when expandDates is turned off
        this.searchData();
      }
    },
  },
  async created() {
    this.$data.search.language = this.$route.query.language || "EN";
    await Promise.all([
      this.searchData(),
      this.fetchAllLanguages(),
      this.getRelatedArticles(),
      this.getRelatedMusic(),
      this.fetchAllDailyStatus(),
      this.fetchAllGods(),
    ]);

    if (!this.$data.search.language) {
      this.$data.search.language = "EN";
    }
    if (this.$route.query.language) {
      this.$data.search.language = this.$route.query.language;
      this.searchData();
    }
  },
};
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  margin-top: 25px;
  margin-right: 5px;
  width: 30%;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
